
import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X } from 'lucide-react';

interface DemoModalProps {
  isOpen: boolean;
  onClose: () => void;
  embedUrl: string;
  title: string;
}

const DemoModal: React.FC<DemoModalProps> = ({ isOpen, onClose, embedUrl, title }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        className="max-w-full w-full h-full max-h-full p-0 border-0 rounded-none"
        hideCloseButton={true}
      >
        {/* Custom close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-50 bg-black/50 hover:bg-black/70 text-white rounded-full p-2 transition-colors"
        >
          <X size={20} />
        </button>
        
        {/* Title bar */}
        <div className="absolute top-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-sm px-6 py-3 border-b">
          <h3 className="text-lg font-semibold text-gray-900">{title} - Live Demo</h3>
        </div>
        
        {/* Embedded iframe with mobile bottom padding */}
        <iframe
          src={embedUrl}
          className="w-full h-full mt-16 pb-4 md:pb-0"
          frameBorder="0"
          allowFullScreen
          title={`${title} Demo`}
        />
      </DialogContent>
    </Dialog>
  );
};

export default DemoModal;
